import { Suspense, lazy } from 'react'
import { useParams } from 'react-router-dom'
import MonetizationSlot from '../components/MonetizationSlot'
import PdfToolFaq from '../components/PdfToolFaq'
import RelatedTools from '../components/RelatedTools'
import { tools } from '../data/tools'

const GrowthAssessment = lazy(() => import('../tools/GrowthAssessment'))
const JsonFormatter = lazy(() => import('../tools/JsonFormatter'))
const TimestampConverter = lazy(() => import('../tools/TimestampConverter'))
const Base64Codec = lazy(() => import('../tools/Base64Codec'))
const UrlCodec = lazy(() => import('../tools/UrlCodec'))
const RegexTester = lazy(() => import('../tools/RegexTester'))
const ImageMetadata = lazy(() => import('../tools/ImageMetadata'))
const ImageCompressor = lazy(() => import('../tools/ImageCompressor'))
const BatchImageCompressor = lazy(() => import('../tools/BatchImageCompressor'))
const ImageWatermark = lazy(() => import('../tools/ImageWatermark'))
const ImageToWebp = lazy(() => import('../tools/ImageToWebp'))
const ImageResizer = lazy(() => import('../tools/ImageResizer'))
const ImagesToPdf = lazy(() => import('../tools/ImagesToPdf'))
const PdfRotate = lazy(() => import('../tools/PdfRotate'))
const PdfMerge = lazy(() => import('../tools/PdfMerge'))
const PdfCompressor = lazy(() => import('../tools/PdfCompressor'))
const PdfSplit = lazy(() => import('../tools/PdfSplit'))
const PdfTextExtractor = lazy(() => import('../tools/PdfTextExtractor'))
const PdfOcrTextExtractor = lazy(() => import('../tools/PdfOcrTextExtractor'))
const TextToolbox = lazy(() => import('../tools/TextToolbox'))
const QrCodeGenerator = lazy(() => import('../tools/QrCodeGenerator'))
const ImageCropper = lazy(() => import('../tools/ImageCropper'))
const IdPhotoCropper = lazy(() => import('../tools/IdPhotoCropper'))
const ImageFormatConverter = lazy(() => import('../tools/ImageFormatConverter'))
const PdfToImages = lazy(() => import('../tools/PdfToImages'))
const ClipboardShare = lazy(() => import('../tools/ClipboardShare'))
const ParentResourceDashboard = lazy(() => import('../tools/ParentResourceDashboard'))

const ToolDetail = () => {
  const { toolId } = useParams()
  const currentTool = tools.find(tool => tool.id === toolId)
  const shouldShowPdfFaq = currentTool?.categorySlug === 'pdf'

  const renderTool = () => {
    switch (toolId) {
      case 'json-formatter':
        return <JsonFormatter />
      case 'timestamp-converter':
        return <TimestampConverter />
      case 'base64-codec':
        return <Base64Codec />
      case 'url-codec':
        return <UrlCodec />
      case 'regex-tester':
        return <RegexTester />
      case 'image-metadata':
        return <ImageMetadata />
      case 'image-compressor':
        return <ImageCompressor />
      case 'batch-image-compressor':
        return <BatchImageCompressor />
      case 'image-watermark':
        return <ImageWatermark />
      case 'image-to-webp':
        return <ImageToWebp />
      case 'image-resizer':
        return <ImageResizer />
      case 'image-cropper':
        return <ImageCropper />
      case 'id-photo-cropper':
        return <IdPhotoCropper />
      case 'image-format-converter':
        return <ImageFormatConverter />
      case 'images-to-pdf':
        return <ImagesToPdf />
      case 'pdf-merge':
        return <PdfMerge />
      case 'pdf-compressor':
        return <PdfCompressor />
      case 'pdf-rotate':
        return <PdfRotate />
      case 'pdf-split':
        return <PdfSplit />
      case 'pdf-text-extractor':
        return <PdfTextExtractor />
      case 'pdf-ocr-text-extractor':
        return <PdfOcrTextExtractor />
      case 'pdf-to-images':
        return <PdfToImages />
      case 'text-toolbox':
        return <TextToolbox />
      case 'qr-code-generator':
        return <QrCodeGenerator />
      case 'clipboard-share':
        return <ClipboardShare />
      case 'parent-resource-dashboard':
        return <ParentResourceDashboard />
      case 'growth-assessment':
        return <GrowthAssessment />
      default:
        return (
          <div className="container mx-auto px-4 py-8">
            <div className="text-center">
              <h1 className="text-2xl font-bold text-gray-900 mb-4">工具未找到</h1>
              <p className="text-gray-600">抱歉，您请求的工具不存在。</p>
            </div>
          </div>
        )
    }
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Suspense fallback={<div className="px-4 py-10 text-center text-slate-500">工具加载中...</div>}>
        {renderTool()}
      </Suspense>
      {shouldShowPdfFaq && (
        <div className="px-4">
          <PdfToolFaq />
        </div>
      )}
      {currentTool && (
        <div className="px-4 pb-10">
          <RelatedTools toolIds={currentTool.relatedToolIds || []} />
          <MonetizationSlot />
        </div>
      )}
    </div>
  )
}

export default ToolDetail
